import { store } from "src/lib/storage";

export const useStore = <TValue>(key: string) => ({
  set: (value: TValue) => store.set(key, value),
  get: () => store.get(key) as TValue,
  clear: () => store.clear(),
  keys: () => store.keys(),
  remove: (key: string) => store.remove(key),
});
